<template>
  <div class="number-modal">
    <div class="number-modal-body">
      <div class="number-body">
        <div class="number-body-title">
          <p>
            {{ phoneNumber }} утасны дугаар луу илгээсэн баталгаажуулах код
            оруулах
          </p>
        </div>
        <div class="number-body-form">
          <form action="" @submit.prevent="sendNumber">
            <input
              type="text"
              placeholder="Баталгаажуулах код оруулна уу"
              v-on:keyup="checkNumber"
              v-model="number"
            />
            <div class="number-error" v-if="error">
              <p>{{ errorMessage }}</p>
            </div>
            <input
              type="submit"
              value="БАТАЛГААЖУУЛАХ"
              class="btn login-btn"
              :disabled="isDisabled"
              :class="{ someSpace: error }"
            />
          </form>
        </div>
      </div>
      <div class="number-footer">
        <p>
          Утасны дугаар оруулснаар дараагийн удаад нэвтрэх түлхүүр үг болох
          боломжтой.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import EventBus from "@/EventBus.js";
export default {
  props: ["phoneNumber"],
  data() {
    return {
      number: "",
      error: false,
      errorMessage: "",
      isDisabled: false,
    };
  },
  methods: {
    RedirectLogin() {
      EventBus.$emit("GLOBAL_ERROR", "error");
    },
    sendNumber() {
      this.isDisabled = true;
      var userNumber = this.number.replace(/\s/g, "");
      var isnum = /^\d+$/.test(userNumber);
      if (userNumber.length === 4 && isnum) {
        var tokenId = localStorage.getItem("authToken");
        if (tokenId == null) {
          this.RedirectLogin();
          this.$auth.destroyToken();
          this.$auth.removeMe();
          this.$router.push({ name: "login" });
        }
        var secureCode = this.number;
        this.$bonusApi
          .post(
            `auth/check/code/phone`,
            {
              tokenId,
              phoneNumber: this.phoneNumber,
              code: secureCode,
              type: "NewUser",
            },
            {
              headers: {
                "Content-Type": "application/json",
                "Accept-Language": "mn",
              },
            }
          )
          .then((response) => {
            if (response.data === true) {
              this.$emit("endNumber");
            } else {
              this.errorMessage = "Баталгаажуулах код буруу байна.";
              this.error = true;
              this.$insProgress.finish();
              this.isDisabled = false;
            }
          })
          .catch((error) => {
            this.errorMessage =
              (error.response && error.response.data && error.response.data.message) ||
              "Баталгаажуулах код буруу байна.";
            this.error = true;
            this.isDisabled = false;
            this.$insProgress.finish();
          });
      } else {
        this.error = true;
        this.errorMessage = "Та зөвхөн 4 оронтой тоо оруулна уу ?";
        this.isDisabled = true;
      }
    },
    checkNumber() {
      var number = this.number;
      var isnum = /^\d+$/.test(number);
      if (!isnum) {
        this.error = true;
        this.errorMessage = "Та зөвхөн тоо оруулна уу ?";
        this.isDisabled = true;
      } else {
        this.error = false;
        this.errorMessage = "";
        this.isDisabled = false;
      }
    },
  },
};
</script>

<style scoped></style>
